<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
</style>
<template>
  <div class="l-edit-dialog-box" style="padding-top:15px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane label="基本信息" name="first">
        <div class="ivu-tabs-tabpane" style="visibility: visible;">
          <div data-v-75eea3a4="" class="ivu-pb">
            <div data-v-75eea3a4="" class="row">
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">场所名称</p>
                <div data-v-75eea3a4="">{{form_data.name}}</div>
              </div>
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">场所类型</p>
                <div data-v-75eea3a4="">{{form_data.type_name}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane> -->
      <el-tab-pane label="隐患描以及整改建议" name="first">
        <div style="margin-bottom: 8px;">
          <l-auth-button type="primary" class="ivu-mr" auth="rental_hazard_description_add_btn" @click="showAdd()"> 添加 </l-auth-button>
          <l-auth-button type="primary" auth="specs_import_btn" @click="import_visible=true" :loading="import_loading"> 导入 </l-auth-button>
        </div>
        <l-table :data="form_data" v-loading="loading" row-key="id" style=" max-height: 30vh;">
        
          <el-table-column prop="danger_lavel" label="隐患等级" width="100">
            <template slot-scope="{ row }">
              <el-tag type="danger" size="small" v-if="row.danger_lavel == 1" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
              <el-tag type="warning" size="small" v-if="row.danger_lavel == 2" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
              <el-tag type="success" size="small" v-if="row.danger_lavel == 3" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
              <el-tag type="success" size="small" v-if="row.danger_lavel == 4" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
              <a size="small" v-else disable-transitions></a>
            </template>
          </el-table-column>
            <el-table-column  prop="class_name" label="隐患类型" min-width="200"> </el-table-column>
              <el-table-column  prop="danger" label="隐患描述" min-width="200"> </el-table-column>
          <el-table-column prop="rectification" label="整改建议" min-width="200"> </el-table-column>
          <el-table-column prop="expect_day" label="建议整改期限(天)" min-width="100"> </el-table-column>
          <el-table-column prop="created_name" label="添加人" min-width="120"> </el-table-column>
          <el-table-column fixed="right" label="操作"  min-width="120" align="center">
            <template slot-scope="{ row }">
              <l-auth-text-button type="primary" auth="rental_hazard_description_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>修改</l-auth-text-button>
              <span class="l-action-separator">|</span>
              <l-auth-text-button type="danger" auth="rental_hazard_description_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
            </template>
          </el-table-column>
        </l-table>
      </el-tab-pane>
    </el-tabs>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
    </div>

    <!--修改-->
    <l-dialog :visible.sync="edit_visible" title="修改" width="600px">
      <l-rental-info-edit @on-success="onEditSucess" :visible.sync="edit_visible" :id="edit_id"></l-rental-info-edit>
    </l-dialog>
    <!--添加-->
    <l-dialog :visible.sync="save_visible" title="添加" width="600px">
      <l-rental-info-edit @on-success="onAddSucess" :visible.sync="save_visible" :specs_id="specs_id"></l-rental-info-edit>
    </l-dialog>

    <!--导入-->
    <l-dialog :visible.sync="import_visible" title="导入" width="800px">
      <l-info-import @on-success="onImportSuccess" :visible.sync="import_visible" />
    </l-dialog>
  </div>

</template>

<script>
import { LEVEL } from './rental';
import InfoImport from "./InfoImport.vue";
import InfoSave from "./InfoSave.vue";
export default {
  name: 'l-retal-info',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
    [InfoSave.name]: InfoSave,
    [InfoImport.name]: InfoImport
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      activeName: 'first',
      loading: false,//页面是否加载中
      //表单数据
      edit_id: 0,
      edit_visible: false,
      save_visible: false,
      form_data: [],
      specs_id: 0,
      LEVEL:LEVEL,
      import_visible:false
    }
  },
  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    handleClick() {
    },
    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //显示添加界面
    showAdd() {
      //   // console.log(this.specs_id)
      this.$nextTick(() => {
        this.save_visible = true;
      });
    },

    //添加成功回调
    onAddSucess() {
      this.save_visible = false;
      this.getData();
    },
    //编辑成功回调
    onEditSucess() {
      this.show_edit = false;
      this.getData();
    },
    //获取数据
    getData() {
      if (this.hasId) {
        this.specs_id = this.$props.id;
        this.loading = true;
        this.$_invoke(`checkSpecs_proposalGetList`, { specs_id: this.$props.id }).then((ret) => {
          this.form_data = ret.data
        }).finally(() => {
          this.loading = false;
        });

      }
    },
    // inspectInfo() {
    //   // // console.log(row);
    // },
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`checkSpecs_proposalDel`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getData();
          });
        })
        .catch(() => { });
    },
    //显示导入
    onImportSuccess() {
      this.import_visible = false;
      this.getData();
    },

  },
}
</script>